import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { EntityDirectoryService } from 'src/app/v2/views/entity-directory/entity-directory.service';

@Component({
  selector: 'entity-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.scss']
})
export class EntityDetailComponent implements OnInit {
  tab: string = '';
  // This controls the view switch buttons.
  views = [{
    id: 'grid',
    isActive: true,
    name: 'Card View',
    src: 'legacy/assets/img/v2-icons/Grid.svg',
    style: {
      position: 'relative',
      top: '-1px'
    }
  }, {
    id: 'compact',
    name: 'List View',
    src: 'legacy/assets/img/v2-icons/List.svg'
  }];
  constructor(private _router: Router,
    private route: ActivatedRoute,
    public service: EntityDirectoryService) { }

  /**
   * On initialization, ensures we grab any changes to the route so we can
   * set the proper entity ID within the service.
   */
  ngOnInit() {
    this.route.paramMap.subscribe(this.onRouteParamsChanged.bind(this));
  }

  ngOnDestroy() {
    this.service.initTransactions();
  }

  /**
   * Navigate to one of the tabs, thereby changing the content.
   */
  changeTab(event) {
    this._router.navigate([event.value], { relativeTo: this.route });
  }

  /**
   * Given the current route, get the most relevant tab from the routing path.
   */
  getTab() {
    try {
      this.tab = this.route.snapshot.children[0].url[0].path;
    } catch (err) {
      console.warn('Whoops, no entity detail path was defined, defaulting' +
        ' to dashboard.');
    }
    return this.tab;
  }

  /**
   * Goes back to the first non-detail page.  This maps to the UI back button.
   */
  goBack() {
    this.service.gotoFirstNonDetailPage();
  }

  /**
   * Called when the route is changed, this will grab the entity ID and trigger
   * the proper data to be obtained.
   * @param params
   */
  onRouteParamsChanged(params) {
    if (params.get('id')) {
      this.service.entityId = params.get('id');
    } else {
      this.service.entityId = null;
    }
  }
}
